import axios, {
  AxiosRequestConfig,
  AxiosRequestHeaders,
  ResponseType,
} from 'axios';
import env from 'config';
import { Controllers } from 'lib/enums/routes/_controllers';

interface ServiceConfig {
  controller: Controllers;
  headers?: HeadersInit;
}

interface RequestConfig {
  uri: string;
  params?: AxiosRequestConfig;
  headers?: AxiosRequestHeaders;
  responseType?: ResponseType;
}

const httpClient = axios.create({
  baseURL: env.server_url,
  withCredentials: true,
});

const DEFAULT_HEADERS = {
  // "Content-Type": "application/json",
  // env: env.identifier,
};

export class BaseService {
  constructor(private config: ServiceConfig) {}

  async GET(request: RequestConfig = { uri: '' }): Promise<any> {
    try {
      const url = `${this.config.controller}/${request.uri}`;

      const config = {
        params: request.params,
        headers: {
          ...DEFAULT_HEADERS,
          ...request.headers,
        },
      };

      return httpClient
        .get(url, config)
        .then((result) => {
          return result.data;
        })
        .catch((error) => {
          console.error(error);
          return;
        });
    } catch (e) {
      console.error(e);
      return;
    }
  }

  async DELETE(request: RequestConfig = { uri: '' }): Promise<any> {
    try {
      const url = `${this.config.controller}/${request.uri}`;

      const config = {
        params: {
          ...request.params,
        },
        headers: {
          ...DEFAULT_HEADERS,
          ...request.headers,
        },
      };

      return httpClient
        .delete(url, config)
        .then((result) => {
          return result.data;
        })
        .catch((error) => {
          console.error(error);
          return;
        });
    } catch (e) {
      console.error(e);
      return;
    }
  }

  async POST(request: RequestConfig = { uri: '' }, data: any): Promise<any> {
    try {
      const url = `${this.config.controller}/${request.uri}`;

      const config = {
        params: {
          ...request.params,
        },
        headers: {
          ...DEFAULT_HEADERS,
          ...request.headers,
        },
      };

      return httpClient
        .post(url, data, config)
        .then((result) => {
          return result.data;
        })
        .catch((error) => {
          console.error(error);
          return;
        });
    } catch (e) {
      console.error(e);
      return;
    }
  }

  async PUT(request: RequestConfig = { uri: '' }, data: any): Promise<any> {
    try {
      const url = `${this.config.controller}/${request.uri}`;

      const config = {
        params: request.params,
        headers: {
          ...DEFAULT_HEADERS,
          ...request.headers,
        },
      };

      return httpClient
        .put(url, data, config)
        .then((result) => {
          return result.data;
        })
        .catch((error) => {
          console.error(error);
          return;
        });
    } catch (e) {
      console.error(e);
      return;
    }
  }

  async PATCH(request: RequestConfig = { uri: '' }, data: any): Promise<any> {
    try {
      const url = `${this.config.controller}/${request.uri}`;

      const config = {
        params: request.params,
        headers: {
          ...DEFAULT_HEADERS,
          ...request.headers,
        },
      };

      return httpClient
        .patch(url, data, config)
        .then((result) => {
          return result.data;
        })
        .catch((error) => {
          console.error(error);
          return;
        });
    } catch (e) {
      console.error(e);
      return;
    }
  }
}
